import { useEffect, useMemo } from 'react';
import {
  CONTENT_DELIVERY_METHOD,
  CONTENT_PROVIDER_D2L,
  CONTENT_PROVIDER_D2L_LABELS,
  CONTENT_PROVIDER_ESSENTIAL_ED,
  CONTENT_PROVIDER_ESSENTIAL_ED_LABELS,
  CategoryType
} from '../../../../../../services/constants';
import useUnleashHook from '../../../../../../core/unleash/useUnleashHook';
import UnleashService from '../../../../../../services/unleash/unleash.service';

const useProgramMetadataHook = (formData, handleChange, categories) => {
  const showBestDropdown = useUnleashHook(UnleashService.FLAGS.SHOW_BEST_DROPDOWN_IN_SUPER_ADMIN_TOOL).isFlagEnabled();
  useEffect(() => {
    if (formData?.contentDeliveryMethod === CONTENT_DELIVERY_METHOD.ESSENTIAL_ED) {
      handleChange({
        target: {
          name: 'certificateEligibility',
          type: 'checkbox',
          checked: false
        }
      });
    }
  }, [formData?.contentDeliveryMethod]);

  const getContentProviderOptions = (deliveryMethod) => {
    if (deliveryMethod === CONTENT_DELIVERY_METHOD.D2L) {
      return {
        options: Object.values(CONTENT_PROVIDER_D2L),
        labels: CONTENT_PROVIDER_D2L_LABELS
      };
    } else if (deliveryMethod === CONTENT_DELIVERY_METHOD.ESSENTIAL_ED) {
      return {
        options: Object.values(CONTENT_PROVIDER_ESSENTIAL_ED),
        labels: CONTENT_PROVIDER_ESSENTIAL_ED_LABELS
      };
    }
    return {
      options: [],
      labels: {}
    };
  };

  const extractCategoryData = (categoriesList, categoryType) => {
    if (!Array.isArray(categoriesList)) return { list: [], labels: {} };

    const names = categoriesList
      .filter(c => c?.type === categoryType)
      .map(c => c?.name || '')
      .filter(Boolean);

    const labels = names.reduce((acc, name) => {
      acc[name] = name;
      return acc;
    }, {});

    return { list: names, labels };
  };


  const { list: bestCategoriesList, labels: bestCategoriesLabels } = useMemo(
    () => extractCategoryData(categories, CategoryType.BEST),
    [categories]
  );

  return {
    getContentProviderOptions,
    showBestDropdown,
    bestCategoriesList,
    bestCategoriesLabels
  };
};

export default useProgramMetadataHook;
